import setReduxAction from 'modules/redux/actions/set'
import addReferenceUtil from 'modules/training/modules/references/utils/add'
import { REFERENCES_ACTION } from 'modules/training/modules/references/constants'

function addReferenceAction (payload) {
  return (dispatch, getState) => {
    const addReferenceObj = addReferenceUtil({
      ...payload,
      state: getState()
    })
    // If the reference already exists, no-op
    if (!addReferenceObj) {
      return
    }
    dispatch(
      setReduxAction({
        type: REFERENCES_ACTION.ADD,
        payload: {
          path: addReferenceObj.referencesPath,
          value: addReferenceObj.newReferences,
          options: {
            step: 1
          }
        }
      })
    )
  }
}

export default addReferenceAction
